<template>
  <div class="flex flex-col min-h-screen items-center">
    <div class="flex justify-between items-center w-full max-w-[1280px]">
      <div class="ml-4 sm:ml-0">
        <LogoIcon />
      </div>
      <div class="h-12 mt-5 mb-5 mr-4 sm:mr-8">
        <LanguageSwitch />
      </div>
    </div>
    <div class="max-w-[460px] w-full text-center flex-grow px-4">
      <h2 class="mt-5 mt-10 mb-6 text-center">
        {{ $t('messages.change_email.title') }}
      </h2>
      <span class="b2 block text-left w-full mb-2 text-zyxel-gray-800">{{ $t('messages.change_email.description') }}</span>
      <button
        class="button-primary w-full mt-4 mb-3"
        @click="handleChangeEmail"
      >
        {{
          $t('messages.button.confirm') }}
      </button>
    </div>
    <EmailChangeSuccessDialog
      :is-visible="showEnableModal"
      @logout="logOutAll"
    />
    <ZyxelFooter />
  </div>
</template>
<script>
import LogoIcon from '@/components/LogoIcon.vue';
import LanguageSwitch from "@/components/LanguageSwitch.vue";
import EmailChangeSuccessDialog from "@/components/EmailChangeSuccessDialog.vue";
import ZyxelFooter from "@/components/ZyxelFooter.vue";
import axios from 'axios';
import { apiBaseUrl } from '@/config';
import { useAuthStore } from '@/stores/auth';
import { logger } from '@/utils/logger';

export default {
    name: 'ChangeEmailPage',
    components: {
        LogoIcon,
        LanguageSwitch,
        ZyxelFooter,
        EmailChangeSuccessDialog
    },
    data() {
        return {
            showEnableModal: false,
        };
    },
    methods: {
        async handleChangeEmail() {
            const queryParams = this.$route.query;
            const pre = queryParams.pre;
            const token = queryParams.token;

            try {
                const response = await axios.post(`${apiBaseUrl}/api/users/set_change_email`, {
                    pre: pre,
                    token: token
                });

                if (response.status === 401) {
                    alert("Sorry, your link has expired. Please request a new one.");
                    this.$router.push({ name: 'SignIn' });
                }
                else if (response.status === 400) {
                    alert('An unknown error occurred, please re-operate the "change email" process.');
                    this.$router.push({ name: 'SignIn' });
                }
                else if (response.status === 200) {
                    this.showEnableModal = true;
                }
            } catch (error) {
                logger.log(error);
                alert('An unknown error occurred, please re-operate the "change email" process.');
                this.$router.push({ name: 'SignIn' });
            }
        },
        async logOutAll() {
            const auth = useAuthStore();
            await auth.signoutAll();
            this.showEnableModal = false;
            this.$router.push({ name: 'SignIn' });
        }
    },
}
</script>